/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import useAPIHandler from '../hook/use-api-handler';
import { logger } from '../utils/logger';

const useOrgDetailsFullDataHook = () => {
    const [organizationFullInfo, setOrganizationFullInfo] = useState({})
    const { fetchData } = useAPIHandler();
    const fetchOrgDetailsData = async () => {
        try {
            const url = "https://api.nouee.com/v1/report/esi?month=1&year=2025&pageLimit=25&page=1&search=yyyy"
            const response = await fetchData({
                url: url,
                method: 'GET',
            });
            setOrganizationFullInfo(response?.data?.org_details)
            logger.log(response, "uuuu-full-deatail")
        } catch (error) {
            logger.log(error)
        }
    }
    useEffect(() => {
        fetchOrgDetailsData()
    }, [])
    return {
        organizationFullInfo
    }
}

export default useOrgDetailsFullDataHook